import type { NotificationType } from "@prisma/client"

export const PROJECT_NOTIFICATION_TYPES: NotificationType[] = [
  "NEW_MACROTREND_PROJECT_ITEM",
  "NEW_MEGATREND_PROJECT_ITEM",
  "NEW_SUBTREND_PROJECT_ITEM",
  "NEW_INNOVATION_PROJECT_ITEM",
  "NEW_INDUSTRY_PROJECT_ITEM",
  "NEW_REGION_PROJECT_ITEM",
  "NEW_REPORT_PROJECT_ITEM",
  "NEW_STAT_PROJECT_ITEM",
  "USER_ADDED_TO_PROJECT",
  "PROJECT_DELETED",
  "PROJECT_EDITED",
  "USER_ADDED_TO_PROJECT",
]

export const ACCOUNT_NOTIFICATION_TYPES: NotificationType[] = ["NEW_COMPANY_USER", "NEW_INVOICE", "USER_ROLE_UPDATED"]

export const CONTENT_NOTIFICATION_TYPES: NotificationType[] = [
  "NEW_REPORT",
  "NEW_ANALYST_PICK_STAT",
  "NEW_INDUSTRY_PICK_INNOVATION",
  "NEW_REGION_PICK_INNOVATION",
  "NEW_SUBTREND",
  "NEW_DAILY",
]
